import { useTranslation } from 'react-i18next';

import {
  FiltersWrapper,
  InputContainer,
  SearchInputContainer,
} from '../../../SimplePage/Filters';
import IconInput from '../../../UI/IconInput/IconInput';
import { MainSelect } from '../../../UI/MainSelect/MainSelect';
import { useMembersFilters } from './membersGeneralListFilters.hooks';
import {
  formatOptionLabel,
  productOptions,
  statusOptions,
} from './membersGeneralListFilters.utils';

const MembersFilters = () => {
  const { t } = useTranslation();
  const { filters, onFilterChangeHandler } = useMembersFilters();

  return (
    <FiltersWrapper>
      <SearchInputContainer>
        <IconInput
          defaultIcon="search"
          onChange={(evt) => onFilterChangeHandler(evt, 'search')}
          placeholder={t('filters.search-by')}
          value={filters.search}
        />
      </SearchInputContainer>
      <InputContainer>
        <MainSelect
          currentValue={filters.productType}
          isClearable
          isMulti
          onChange={(evt: any) => onFilterChangeHandler(evt, 'productType')}
          options={productOptions}
          placeholder={t('filters.product')}
        />
      </InputContainer>
      <InputContainer>
        <MainSelect
          currentValue={filters.status}
          isClearable
          isMulti
          onChange={(evt: any) => onFilterChangeHandler(evt, 'status')}
          options={statusOptions}
          placeholder={t('filters.status')}
          formatOptionLabel={formatOptionLabel}
        />
      </InputContainer>
    </FiltersWrapper>
  );
};

export default MembersFilters;
